const AI_CONSENT_KEY = 'ai_data_consent_accepted';

/** Check if the user has already accepted AI data sharing consent. */
export function hasAIDataConsent(): boolean {
  try {
    return localStorage.getItem(AI_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Record that the user accepted AI data sharing consent. */
export function setAIDataConsent(accepted: boolean): void {
  try {
    if (accepted) {
      localStorage.setItem(AI_CONSENT_KEY, 'true');
    } else {
      localStorage.removeItem(AI_CONSENT_KEY);
    }
  } catch {
    // Storage unavailable
  }
}
